import { useMemo } from 'react'
import { sortRows, type SortAccessors, type SortState } from '@/lib/tableSort'

/**
 * A client-side table's rows in the order its header chose (z8nrz7e4h6).
 *
 * For tables that hold ALL their rows in the browser. A server-paged table must
 * not use this — it would order only the page on screen — and sends
 * `sortParam(cols.sort)` to its list endpoint instead.
 *
 * `accessors` maps each sortable column id to the row's value for it. Declare it
 * at module level (or memoize it) so the sort is not recomputed every render.
 */
export function useSortedRows<T>(
  rows: readonly T[] | null | undefined,
  sort: SortState | null,
  accessors: SortAccessors<T>,
): T[] {
  return useMemo(() => sortRows(rows ?? [], sort, accessors), [rows, sort, accessors])
}
